import { useState } from 'react';
import { COLOMBIA_DEPARTMENTS, COLOMBIA_CITIES, isColombia } from '../data/geo';

// Campos de ubicación reutilizables (departamento, ciudad, barrio, dirección).
// Si el país es Colombia, departamento y ciudad son dropdowns dependientes (al
// elegir departamento salen sus ciudades) con opción "Otra" para escribir libre;
// para cualquier otro país, departamento y ciudad son inputs de texto. El barrio
// y la dirección siempre son texto libre. Ninguno es obligatorio.
//
// Props: pais, department, city, district, address, onChange(campo, valor) y los
// estilos inputStyle / labelStyle (para integrarse con cada formulario).
function LocationFields({ pais, department, city, district, address, onChange, inputStyle, labelStyle }) {
  const colombia = isColombia(pais);
  const deptCities = colombia && department ? (COLOMBIA_CITIES[department] || []) : [];
  const cityIsCustom = colombia && !!city && !deptCities.includes(city);
  const [otra, setOtra] = useState(false);
  const showOtra = otra || cityIsCustom;

  const selectStyle = { ...inputStyle, cursor: 'pointer' };

  const handleDeptChange = (value) => {
    setOtra(false);
    onChange('department', value);
    onChange('city', ''); // al cambiar de departamento, se limpia la ciudad
  };

  const handleCitySelect = (value) => {
    if (value === '__otra__') { setOtra(true); onChange('city', ''); }
    else { setOtra(false); onChange('city', value); }
  };

  return (
    <>
      {/* Departamento */}
      <div style={{ marginBottom: '1rem' }}>
        <label style={labelStyle}>Departamento</label>
        {colombia ? (
          <select value={department || ''} onChange={e => handleDeptChange(e.target.value)} style={selectStyle}>
            <option value="">— Selecciona departamento —</option>
            {COLOMBIA_DEPARTMENTS.map(d => <option key={d} value={d}>{d}</option>)}
          </select>
        ) : (
          <input type="text" value={department || ''} onChange={e => onChange('department', e.target.value)} style={inputStyle} placeholder="Ej: departamento / estado / provincia" />
        )}
      </div>

      {/* Ciudad */}
      <div style={{ marginBottom: '1rem' }}>
        <label style={labelStyle}>Ciudad</label>
        {colombia ? (
          <>
            <select
              value={showOtra ? '__otra__' : (city || '')}
              onChange={e => handleCitySelect(e.target.value)}
              disabled={!department}
              style={selectStyle}
            >
              <option value="">{department ? '— Selecciona ciudad —' : 'Elige primero el departamento'}</option>
              {deptCities.map(ci => <option key={ci} value={ci}>{ci}</option>)}
              {department && <option value="__otra__">Otra ciudad…</option>}
            </select>
            {showOtra && (
              <input
                type="text"
                value={city || ''}
                onChange={e => onChange('city', e.target.value)}
                style={{ ...inputStyle, marginTop: '0.5rem' }}
                placeholder="Escribe tu ciudad"
              />
            )}
          </>
        ) : (
          <input type="text" value={city || ''} onChange={e => onChange('city', e.target.value)} style={inputStyle} placeholder="Ej: ciudad" />
        )}
      </div>

      {/* Barrio */}
      <div style={{ marginBottom: '1rem' }}>
        <label style={labelStyle}>Barrio</label>
        <input type="text" value={district || ''} onChange={e => onChange('district', e.target.value)} style={inputStyle} placeholder="Ej: barrio / sector" />
      </div>

      {/* Dirección */}
      <div style={{ marginBottom: '1rem' }}>
        <label style={labelStyle}>Dirección</label>
        <input type="text" value={address || ''} onChange={e => onChange('address', e.target.value)} style={inputStyle} placeholder="Ej: Cra 10 # 20-30" />
      </div>
    </>
  );
}

export default LocationFields;
